<div class="dialog-panel dialog-post">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }

    <div class="dialog-header">
      <h1 class="dialog-title dot">{{ 'planning.planning_campaign' | transloco }}</h1>
    </div>

    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="formCampaign" (submit)="onSubmit()">
      <div class="dialog-body">
        @if (campaigns.length > 0) {
          <div class="row">
            <div class="col-12 form-field-container">
              <div class="form-field-label">
                {{ 'planning.select_campaign' | transloco }}
              </div>
              <lib-select
                [value]="formCampaign.get('campaign').value"
                [options]="campaigns"
                (valueChange)="setCampaign($event)"
              ></lib-select>
            </div>
          </div>
        }

        <!-- SELECTED CAMPAIGN -->
        @if (selectedCampaign) {
          <div class="active-campaign-container">
            <div class="row flex-md-nowrap">
              @if (selectedCampaign.media?.length > 0) {
                <div class="col-4 col-sm-auto align-self-center">
                  <div
                    class="photo-thumbnail"
                    [lazyLoad]="selectedCampaign.media[0].url1x + '?w=150&h=150&m=2' + addWebp"
                  ></div>
                </div>
              }
              <div class="col-8 col-sm align-self-center campaign-copy">
                {{ selectedCampaign.name }}
              </div>
              @if (selectedCampaign.platforms) {
                <div class="col-12 col-md-auto align-self-center">
                  <div class="socials">
                    @for (platform of selectedCampaign.platforms.split('|'); track platform) {
                      <img class="social-img" [lazyLoad]="'/assets/social/' + platform.toLowerCase() + '.png'" />
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <!-- SELECTED CAMPAIGN -->

        <!-- SELECTED CAMPAIGN DATE -->
        @if (selectedCampaign) {
          <div class="date-container">
            <div class="row">
              <div class="form-field-container col-12 col-md-5">
                <div class="form-field-label">
                  {{ 'form.field.start_date' | transloco }}
                </div>
                <lib-date-time-field [formControlName]="'date'"></lib-date-time-field>
              </div>
            </div>
          </div>
        }
        <!-- SELECTED CAMPAIGN DATE -->
      </div>

      @if (campaigns.length > 0) {
        <div class="dialog-bottom">
          <div class="row">
            <div class="ml-auto col-4">
              <button type="submit" class="btn btn-primary d-block w-100" [disabled]="formCampaign.invalid">
                {{ 'global.select' | transloco }}
              </button>
            </div>
          </div>
        </div>
      }
    </form>
  </div>
</div>
